export default __webpack_public_path__ + "static/media/cube.3ee13fd6.png";